import { render, staticRenderFns } from "./ChallengeEditor.vue?vue&type=template&id=02be8111&scoped=true"
import script from "./ChallengeEditor.vue?vue&type=script&lang=js"
export * from "./ChallengeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02be8111",
  null
  
)

export default component.exports